export type Case = {
  caseId: number;
  caseNumber: string;
  state: CaseState;
  creationDate: Date;
  categoryAlias: number;
  subcategoryAlias: number;
  caseOwner: {
    name: string;
    email: string;
    phone: string;
    title: string;
  };
  employerName: string;
  caseCreationId: string;
};

export type Cases = { cases: Case[] };

export type CaseMessage = {
  caseNoteId: number;
  creationDate: string;
  author: string | null;
  noteText: string;
  documents: CaseDocument[];
  posting?: boolean;
  error?: string;
};

export type CaseDocuments = { documents: CaseDocument[] };

export type CaseDocument = {
  id: number;
  title: string;
  fileName: string;
  extension: string;
};

export type AppendDocument = {
  documentId: string;
  fileName: string;
};

export type CaseDetails = {
  caseId: number;
  caseNumber: string;
  state: CaseState;
  creationDate: string;
  completionDate: string;
  categoryAlias: number;
  categoryName: string;
  subcategoryAlias: number;
  subCategoryName: string;
  department: string;
  caseOwner?: CaseOwner;
  employerName: string;
  employmentType: string;
  employmentTypeName: string;
  caseCreationId: string;
};

export enum CaseState {
  open = 'Open',
  closed = 'Closed',
  closing = 'Closing',
}

export type UiCase = {
  [key: string]: string;
};

export type UiCases = {
  openCases?: UiCase[] | null;
  closedCases?: UiCase[] | null;
  loading: boolean;
};

export type CaseOwner = {
  name: string;
  email: string;
  phone: string;
  title: string;
  outOfOffice?: OutOfOffice;
};

export type OutOfOffice = {
  enabled: boolean;
  startTime: string;
  endTime: string;
};
